/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BenchReportType {
  BAD_DETECTION = "bad_detection",
  INCORRECT_LOCATION = "incorrect_location",
  POOR_IMAGE_QUALITY = "poor_image_quality",
}
